export * from './lib/shared-components.module';
export * from './lib/legacy/etc/interceptors/not-enough-points.interceptor';
